import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
// Create an object by filtering all undefined props from the object supplied as a param

export default function filterObject(obj) {
  var filteredValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [undefined];
  Object.keys(obj).forEach(function (key) {
    return filteredValues.includes(obj[key]) && delete obj[key];
  });
  return obj;
}